import { AutoTableColumnContext } from "./auto-table-column-provider.constants";
import { IProps } from "./auto-table-column-provider.types";

const AutoTableColumnProvider = ({ isBody, children }: IProps) => {
    return <AutoTableColumnContext.Provider value={{ isBody }}>{children}</AutoTableColumnContext.Provider>;
};

export { AutoTableColumnProvider };
